var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconListNumbered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.393 17.62c.397.355.607.834.607 1.384 0 .366-.098.704-.285.994.187.292.285.633.285 1.006 0 .568-.217 1.06-.628 1.418-.576.505-1.396.604-1.95.604a4.25 4.25 0 01-.554-.034 1 1 0 01.26-1.983c.17.021.375.02.55.002-.064-.006-.133-.006-.182-.007h-.048a1 1 0 01-.02-1.999c.027 0 .073 0 .119-.002.023 0 .046-.003.07-.005a2.738 2.738 0 00-.512-.003 1.005 1.005 0 01-1.097-.89.999.999 0 01.883-1.099c.27-.03 1.663-.139 2.502.613zM23 19a1 1 0 010 2H9a1 1 0 010-2h14zM4.494 9.52c.454.45.506 1.063.506 1.484 0 .619-.377 1.347-.844 2.012A1 1 0 014 15.004H2a1 1 0 01-.708-1.707c.833-.834 1.633-1.91 1.706-2.29-.18-.007-.423-.006-.635-.004H2a1 1 0 010-2h.35c.9-.004 1.612-.01 2.144.517zM23 11a1 1 0 010 2H9a1 1 0 010-2h14zM3.374 1.074c.378.153.626.52.626.928v4a1 1 0 01-2 0V4a1.001 1.001 0 01-.683-1.693l.962-1a.999.999 0 011.095-.235zM23 3a1 1 0 010 2H9a1 1 0 010-2h14z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconListNumbered;